import React from 'react';
import styled from 'styled-components';

import useIsFeatureEnabled from 'components/hooks/use_is_feature_enabled';

export default function PaymentOverdueBanner() {
  const isFeatureEnabled = useIsFeatureEnabled();
  if (!isFeatureEnabled('paymentOverdueBanner')) return null;

  return (
    <Container>
      <Content>
        <Message>
          Your account is past due. Please contact <a href="mailto:ar@gladly.com">ar@gladly.com</a> to remit payment and
          ensure uninterrupted access to Gladly.
        </Message>
      </Content>
    </Container>
  );
}

const Container = styled.div`
  position: fixed;
  top: 0px;
  width: 100%;
  background: ${({ theme }) => theme.colors.yellow100};
  z-index: 1000;
  display: flex;
`;

const Content = styled.div`
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const Message = styled.div``;
